// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"b987e3eabf5fddfce57e","293":"797f9316ed50b71b7612","518":"468c27728daa15c1643f","779":"7fa3d35de7b14b281951"}[chunkId] + ".js";
};